var map = {
	"./": [
		50130
	],
	"./gift": [
		1454,
		96596
	],
	"./gift.jsx": [
		1454,
		96596
	],
	"./index": [
		50130,
		54826
	],
	"./index.jsx": [
		50130,
		54826
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 47972;
module.exports = webpackAsyncContext;